import { TimelineMax } from "gsap";
import { IShakeConfig } from "./IAnimationEffects";

export class AnimationEffects {

    public static Yoyo(config:IShakeConfig):TimelineMax{
        let startPosY:number = config.obj.y;
        let startPosX:number = config.obj.x;
        let t:boolean = true;
        const tl:TimelineMax = new TimelineMax({
            onComplete:() => {
                if(config.positionCb){
                    config.obj.x = config.positionCb().x;
                    config.obj.y = config.positionCb().y;
                }else if(config.updateOnComplete){
                    config.obj.y = startPosY;
                    config.obj.x = startPosX;
                }
            },
            onUpdate:() => {
                const nt:number = tl.progress();
                const lt:number = tl.time();
                let et:number = config.ease ? config.ease.getRatio(nt) as number : nt;
                if(config.reverseEase) et = 1 - et;
                if(t){
                    t = false;
                    return;
                }
                if(config.positionCb){
                    startPosX = config.positionCb().x;
                    startPosY = config.positionCb().y;
                }

                config.obj.x = startPosX + config.x*et;
                config.obj.y = startPosY + config.y*et;
            }
        });
        tl.to(this,config.duration,{})
        return tl;
    }


    public static Shake(config:IShakeConfig):TimelineMax{
        let startPosY:number = config.obj.y;
        let startPosX:number = config.obj.x;

        let t:boolean = true;
        const tl:TimelineMax = new TimelineMax({
            onStart:() => {
                startPosY = config.obj.y;
                startPosX = config.obj.x;
            },
            onComplete:() => {
                if(config.positionCb){
                    config.obj.x = config.positionCb().x;
                    config.obj.y = config.positionCb().y;
                }
                else if(config.updateOnComplete){
                    config.obj.y = startPosY;
                    config.obj.x = startPosX;
                }
            },
            onUpdate:() => {
                const nt:number = tl.progress();
                const lt:number = tl.time();
                let et:number = config.ease ? config.ease.getRatio(nt) as number : nt;
                if(t){
                    t = false;
                    return;
                }
                if(config.positionCb){
                    startPosX = config.positionCb().x;
                    startPosY = config.positionCb().y;
                }

                if(config.reverseEase)
                    et = 1 - et;
                if(config.Intensity){
                    if(config.y != 0)
                        config.obj.y = startPosY + Math.cos(lt*config.hertz) * (config.Intensity*et)  * config.y;
                    if(config.x != 0)
                        config.obj.x = startPosX + (Math.sin(lt*config.hertz) * (config.Intensity*et)) * config.x;
                }
                else{
                    if(config.y != 0)
                        config.obj.y = startPosY + (Math.cos(lt*config.hertz) * et) * config.y;
                    if(config.x != 0)
                        config.obj.x = startPosX + (Math.sin(lt*config.hertz) * et) * config.x;
                }
            }
        });
        tl.to(this,config.duration,{})
        return tl;
    }
}